import { progress } from 'motion-utils';
var generateLinearEasing = function generateLinearEasing(easing, duration) {
  var resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var points = "";
  var numPoints = Math.max(Math.round(duration / resolution), 2);
  for (var i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }
  return "linear(".concat(points.substring(0, points.length - 2), ")");
};
export { generateLinearEasing };